import { defineStore } from 'pinia';
import { useBackendApiPost } from '@/composables/useBackendApi';
import { type AuthResponse } from '@/types/AuthTypes';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null as string | null,
    user: null as string | null
  }),
  actions: {
    async fetchToken(username: string, password: string) {
      try {
        const response = await useBackendApiPost<AuthResponse>('auth', { username, password });

        if (response) {
          this.token = response.jwt;
          this.user = response.username;
          localStorage.setItem('token', this.token ?? '');
          localStorage.setItem('user', this.user ?? '');
          //@TODO: Timestamp zur partiellen Löschung wenn älter als eine Woche
          localStorage.setItem('token_timestamp', Date.now().toString());
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Tokens:', error);
      }
    },
    // loadToken() {
    //   if (process.client) {
    //     this.token = localStorage.getItem('token');
    //     this.user = localStorage.getItem('user');
    //   }
    // }
    loadToken() {
      if (process.client) {
        const timestamp = localStorage.getItem('token_timestamp');
        const maxAge = 7 * 24 * 60 * 60 * 1000;

        if (timestamp && (Date.now() - Number(timestamp)) <= maxAge) {
          this.token = localStorage.getItem('token');
          this.user = localStorage.getItem('user');
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('token_timestamp');

          this.token = null;
          this.user = null;
        }
      }
    }
  }
});

